import React from 'react';
import { StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { useVideoPlayer, VideoView } from 'expo-video';
import { useTheme } from '../../theme/ThemeContext';

interface FeedVideoPlayerProps {
  uri: string;
  style?: StyleProp<ViewStyle>;
}

const FeedVideoPlayer: React.FC<FeedVideoPlayerProps> = ({ uri, style }) => {
  const { theme } = useTheme();
  const player = useVideoPlayer(uri, (instance) => {
    instance.loop = false;
    instance.muted = false;
    instance.volume = 1;
  });

  return (
    <VideoView
      style={[styles.video, { backgroundColor: theme.backgroundSecondary }, style]}
      player={player}
      allowsFullscreen
      allowsPictureInPicture
      nativeControls
      contentFit="contain"
    />
  );
};

const styles = StyleSheet.create({
  video: {
    width: '100%',
    aspectRatio: 1,
    borderRadius: 28,
    marginTop: 24,
    overflow: 'hidden',
  },
});

export default FeedVideoPlayer;
